import { render, staticRenderFns } from "./PrimarySelectorCta.vue?vue&type=template&id=6ed0bb32&scoped=true&"
import script from "./PrimarySelectorCta.vue?vue&type=script&lang=js&"
export * from "./PrimarySelectorCta.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySelectorCta.vue?vue&type=style&index=0&id=6ed0bb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0bb32",
  null
  
)

export default component.exports